export const totalJudgeResultList = [
  { rank: 'A', labelJP: '良好', labelEN: 'Good' },
  { rank: 'B', labelJP: '差支えなし', labelEN: 'Without exception' },
  { rank: 'C', labelJP: '要経過視察、要生活改善', labelEN: 'Lifestyle habit improvement and observation are necessary.' },
  { rank: 'D', labelJP: '要精密検査、要受診', labelEN: 'Detailed examination needed. Have a medical examination.' },
]